export default __webpack_public_path__ + "media/00c24b72c55b7424806bac3a41ebae78cd2cda0e08d735fa1a5892967cdbb639.svg";